'use client';

import {motion} from 'framer-motion';
import BookBtn from '../buttons/BookBtn/BookBtn';
import heroVariants from '../../animation/heroVariants';


const defaultProps = {
  title: 'We have been at the intersection of cybersecurity and innovation for',
  text: 'In that time we have seen the impact of incidents and the cost and complexity of maintaining both infrastructure and security in a rapidly evolving world. We believe there is a' ,
  highlight: 'more than 30 years.',
  text_highlight: 'better way.'
};

const CompanyHero = ({ title=defaultProps.title, text=defaultProps.text, highlight=defaultProps.highlight, text_highlight=defaultProps.text_highlight }) => {
  return (
    <motion.section
      className='company-hero'
      initial={'hidden'}
      animate={'visible'}
      transition={{
        duration: 0.7,
        delay: 0.5,
        ease: 'easeInOut'
      }}
      variants={heroVariants}
    >
      <div className='container'>
        <div className='bg-icon-top'></div>
        <div className='bg-icon-left'></div>
        <div className='bg-icon-right'></div>
        <div className='bg-icon-mobile'></div>
        <h2 className='title'>
          {title}
          <span className='highlight'> {highlight}</span>
        </h2>
        <p className='text'>
          {text}
          <span className='highlight' style={{paddingLeft: '0.3em'}}>
            {text_highlight}
          </span>
        </p>
        <BookBtn text='Contact us' />
      </div>
    </motion.section>
  );
};
CompanyHero.defaultProps = defaultProps;
export default CompanyHero;

